<router-outlet></router-outlet>
<app-notification-informer />
<app-mobile-alert />
<app-video-player-modal />
<app-image-player-modal />
<app-pdf-viewer-modal />
<app-text-viewer-modal />
<app-word-viewer-modal />
